import { buildModelManager } from "../builder.js";
const DefaultInstitutionalRepositorySelection = {
  __typename: true,
  id: true,
  accessLevel: true,
  assignedCohorts: true,
  attachments: true,
  contentScope: true,
  createdAt: true,
  createdById: true,
  description: { markdown: true, truncatedHTML: true },
  formFields: true,
  institution: true,
  isActive: true,
  isDraft: true,
  itemType: true,
  lastModifiedById: true,
  lastUsed: true,
  name: true,
  parentTemplateId: true,
  passingCriteria: true,
  programArea: true,
  readPermissions: true,
  reportFields: true,
  reportFilters: true,
  requiredRole: true,
  scheduledReports: true,
  scoringRubric: true,
  submissionSettings: true,
  templateData: true,
  updatedAt: true,
  usageCount: true,
  version: true,
  writePermissions: true
};
const modelApiIdentifier = "institutionalRepository";
const pluralModelApiIdentifier = "institutionalRepositories";
;
;
;
;
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultInstitutionalRepositorySelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultInstitutionalRepositorySelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultInstitutionalRepositorySelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultInstitutionalRepositorySelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultInstitutionalRepositorySelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultInstitutionalRepositorySelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultInstitutionalRepositorySelection,
    namespace: null
  },
  {
    type: "action",
    operationName: "createInstitutionalRepository",
    operationReturnType: "CreateInstitutionalRepository",
    functionName: "create",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      institutionalRepository: { required: false, type: "CreateInstitutionalRepositoryInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultInstitutionalRepositorySelection
  },
  {
    type: "action",
    operationName: "bulkCreateInstitutionalRepositories",
    functionName: "bulkCreate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "create",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: {
        required: true,
        type: "[BulkCreateInstitutionalRepositoriesInput!]"
      }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultInstitutionalRepositorySelection
  },
  {
    type: "action",
    operationName: "updateInstitutionalRepository",
    operationReturnType: "UpdateInstitutionalRepository",
    functionName: "update",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      institutionalRepository: { required: false, type: "UpdateInstitutionalRepositoryInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultInstitutionalRepositorySelection
  },
  {
    type: "action",
    operationName: "bulkUpdateInstitutionalRepositories",
    functionName: "bulkUpdate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "update",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: {
        required: true,
        type: "[BulkUpdateInstitutionalRepositoriesInput!]"
      }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultInstitutionalRepositorySelection
  },
  {
    type: "action",
    operationName: "deleteInstitutionalRepository",
    operationReturnType: "DeleteInstitutionalRepository",
    functionName: "delete",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: true,
    variables: { id: { required: true, type: "GadgetID" } },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: false,
    hasCreateOrUpdateEffect: false,
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "bulkDeleteInstitutionalRepositories",
    functionName: "bulkDelete",
    isBulk: true,
    isDeleter: true,
    hasReturnType: false,
    acceptsModelInput: false,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "delete",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { ids: { required: true, type: "[GadgetID!]" } },
    paramOnlyVariables: [],
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "upsertInstitutionalRepository",
    operationReturnType: "UpsertInstitutionalRepository",
    functionName: "upsert",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      on: { required: false, type: "[String!]" },
      institutionalRepository: { required: false, type: "UpsertInstitutionalRepositoryInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: ["on"],
    hasReturnType: {
      "... on CreateInstitutionalRepositoryResult": { hasReturnType: false },
      "... on UpdateInstitutionalRepositoryResult": { hasReturnType: false }
    },
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultInstitutionalRepositorySelection
  },
  {
    type: "action",
    operationName: "bulkUpsertInstitutionalRepositories",
    functionName: "bulkUpsert",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "upsert",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: {
        required: true,
        type: "[BulkUpsertInstitutionalRepositoriesInput!]"
      }
    },
    paramOnlyVariables: ["on"],
    defaultSelection: DefaultInstitutionalRepositorySelection
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "institutionalRepositoryGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
const InstitutionalRepositoryManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultInstitutionalRepositorySelection,
  operations
);
export {
  DefaultInstitutionalRepositorySelection,
  InstitutionalRepositoryManager
};
//# sourceMappingURL=InstitutionalRepository.js.map
